/* Verrou de defilement commun (toudoupet-header.css) : classe tp-has-scrollbar sur <html>
   tant que la page affiche une barre de defilement classique (bureau), mesuree hors
   verrou ; le verrou garde alors la place de la barre (pas de saut de largeur). Execute
   des le chargement du script, avant les autres scripts differes qui peuvent verrouiller. */
(() => {
  const de = document.documentElement;
  const LOCKS = ['tp-menu-open', 'tp-search-open', 'tp-cart-drawer-open', 'tp-promo-locked'];
  const measure = () => {
    if (LOCKS.some((c) => de.classList.contains(c))) return;
    de.classList.toggle('tp-has-scrollbar', window.innerWidth - de.clientWidth > 0);
  };
  measure();
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(de);
  window.addEventListener('resize', measure, { passive: true });
})();

document.addEventListener('DOMContentLoaded', () => {
  const burgerBtn = document.getElementById('tpBurgerBtn');
  const mobileNav = document.getElementById('tpMobileNav');
  const header = document.getElementById('siteHeader');

  /* Menu mobile (<= 1024 px) : panneau superpose sous le header (CSS), hauteur
     limitee a l'ecran restant (--tp-mnav-top), defilement de la page bloque
     pendant l'ouverture (html.tp-menu-open, verrou commun toudoupet-header.css).
     Fermeture : burger, Echap, clic exterieur, focus sorti du menu, passage
     au-dessus de 1024 px. La fenetre de recherche ouverte depuis le menu
     (« Rechercher ») garde le menu ouvert : elle gere elle-meme Echap et le
     retour du focus. */
  if (burgerBtn && mobileNav) {
    const desktopMq = window.matchMedia('(min-width: 1025px)');
    const searchModal = document.getElementById('tpSearchModal');
    const searchIsOpen = () => !!searchModal && !searchModal.hidden;
    const isOpen = () => mobileNav.classList.contains('is-open');

    const setTop = () => {
      const bottom = Math.max(0, Math.round((header || burgerBtn).getBoundingClientRect().bottom));
      mobileNav.style.setProperty('--tp-mnav-top', bottom + 'px');
    };

    const setMenu = (open, restoreFocus) => {
      if (open) setTop();
      mobileNav.classList.toggle('is-open', open);
      burgerBtn.classList.toggle('is-active', open);
      burgerBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      burgerBtn.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      document.body.classList.toggle('tp-menu-open', open);
      document.documentElement.classList.toggle('tp-menu-open', open);
      if (!open && restoreFocus) burgerBtn.focus();
    };

    burgerBtn.addEventListener('click', () => setMenu(!isOpen(), false));

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented || !isOpen() || searchIsOpen()) return;
      setMenu(false, mobileNav.contains(document.activeElement) || document.activeElement === burgerBtn);
    });

    document.addEventListener('click', (e) => {
      if (!isOpen() || searchIsOpen()) return;
      const t = e.target;
      if (mobileNav.contains(t) || burgerBtn.contains(t) || (searchModal && searchModal.contains(t))) return;
      setMenu(false, false);
    });

    /* Le menu (place juste apres le burger dans le DOM) se ferme quand le focus clavier
       le quitte : Tab apres sa derniere entree, Maj+Tab avant le burger. Le focus
       n'atteint jamais la page masquee derriere le panneau. Memes exceptions que le
       clic exterieur ; focus perdu sans cible (fenetre quittee, clic sur un vide) : rien. */
    const onFocusOut = (e) => {
      const t = e.relatedTarget;
      if (!isOpen() || !t || mobileNav.contains(t) || burgerBtn.contains(t) || (searchModal && searchModal.contains(t))) return;
      setMenu(false, false);
    };
    mobileNav.addEventListener('focusout', onFocusOut);
    burgerBtn.addEventListener('focusout', onFocusOut);

    const onDesktop = () => { if (desktopMq.matches && isOpen()) setMenu(false, false); };
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', onDesktop);
    else if (desktopMq.addListener) desktopMq.addListener(onDesktop);
    window.addEventListener('resize', () => { if (isOpen()) setTop(); }, { passive: true });
  }

  const announcementBar = document.querySelector('.tp-announcement-bar');

  if (header) {
    let hasPlayedEntrance = false;

    function applyScrolledState(isScrolled) {
      header.classList.toggle('is-scrolled', isScrolled);
      document.body.classList.toggle('tp-header-scrolled', isScrolled);

      if (isScrolled && !hasPlayedEntrance) {
        hasPlayedEntrance = true;
        header.classList.add('tp-header-enter-once');
      }
    }

    if (announcementBar && 'IntersectionObserver' in window) {
      /* Comportement historique : l'etat "scrolled" suit la sortie d'ecran de la barre d'annonce */
      const observer = new IntersectionObserver(
        ([entry]) => applyScrolledState(!entry.isIntersecting),
        { threshold: 0 }
      );
      observer.observe(announcementBar);
    } else {
      /* Repli si la barre d'annonce est absente : etat "scrolled" base sur la position de defilement */
      let ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          applyScrolledState(window.scrollY > 32);
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* Pastille panier : masquee a 0 article, et libelle du lien panier tenu a jour
     (« Panier, N article(s) »). Le nombre est ecrit par toudoupet-cart.js
     (updateCartBadge) : on observe simplement le texte de la pastille. */
  const cartBtn = document.getElementById('tpCartIconBtn');
  const cartCount = cartBtn && cartBtn.querySelector('.tp-site-header__cart-count');
  if (cartCount) {
    const syncCartBadge = () => {
      const n = parseInt(cartCount.textContent, 10) || 0;
      cartCount.hidden = n === 0;
      cartBtn.setAttribute('aria-label', n > 0 ? 'Panier, ' + n + ' article' + (n > 1 ? 's' : '') : 'Panier');
    };
    syncCartBadge();
    new MutationObserver(syncCartBadge).observe(cartCount, { childList: true, characterData: true, subtree: true });
  }

  /* Sous-menu Catalogue desktop (div.tp-nav-dd--hover, ouvert en CSS au survol /
     focus-within) : Echap le referme (classe is-closed) et rend le focus au lien
     Catalogue ; il redevient disponible quand le pointeur ou le focus quitte puis
     revient sur l'entree. */
  document.querySelectorAll('.tp-nav-dd--hover').forEach((dd) => {
    const trigger = dd.querySelector('.tp-nav-dd__trigger');
    dd.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || dd.classList.contains('is-closed')) return;
      dd.classList.add('is-closed');
      if (trigger) trigger.focus();
    });
    dd.addEventListener('mouseleave', () => dd.classList.remove('is-closed'));
    dd.addEventListener('focusout', (e) => { if (!dd.contains(e.relatedTarget)) dd.classList.remove('is-closed'); });
  });
});
